import React, { useMemo } from 'react';
import cx from 'classnames';
// import { Line as LineType } from 'd3-shape';
// import { AddSVGProps, LinePathConfig } from '../types';
import { line } from '@visx/shape';

// export type LinePathProps<Datum> = {
//   /** Array of data for which to generate a line shape. */
//   data?: Datum[];
//   /** React RefObject passed to the path element. */
//   innerRef?: React.Ref<SVGPathElement>;
//   /** Override render function which is passed the configured path generator as input. */
//   children?: (args: { path: LineType<Datum> }) => React.ReactNode;
//   /** Fill color of the path element. */
//   fill?: string;
//   /** className applied to path element. */
//   className?: string;
// } & LinePathConfig<Datum>;

export default function AreaPath({
  children,
  data = [],
  x,
  yUpper,
  yLower,
  fill = 'transparent',
  className,
  curve,
  innerRef,
  defined = () => true,
  ...restProps
}) {
  const hasData = !!data?.length;

  const pathUpper = useMemo(
    () => line({ x, y: yUpper, defined, curve }),
    [x, yUpper, defined, curve]
  );
  const pathLower = useMemo(
    () => line({ x, y: yLower, defined, curve }),
    [x, yLower, defined, curve]
  );
  const reversedData = useMemo(() => [...data].reverse(), [data]);
  const upperPath = useMemo(() => pathUpper(data), [pathUpper, data]);
  const lowerPath = useMemo(
    () => pathLower(reversedData),
    [pathLower, reversedData]
  );
  const areaPath = useMemo(() => {
    return hasData
      ? `${upperPath} L${x(reversedData[0])} ${yLower(
          reversedData[0]
        )} ${lowerPath} L${x(data[0])} ${yUpper(data[0])} Z`
      : '';
  }, [upperPath, lowerPath, x, yLower, yUpper, reversedData, data, hasData]);

  return hasData ? (
    <path
      ref={innerRef}
      className={cx('visx-linepath', className)}
      d={areaPath || ''}
      fill={fill}
      // without this a datum surrounded by nulls will not be visible
      // https://github.com/d3/d3-shape#line_defined
      strokeLinecap="round"
      {...restProps}
    />
  ) : null;
}
